/** The languages the admin can author content in that are written right-to-left. */
const RTL_LANGUAGES = new Set(["ar"]);

/**
 * The writing direction of a piece of *content*, which is not the direction of
 * the UI around it (MED-1543).
 *
 * Several admin forms carry one value per language behind a tab strip —
 * promotion code labels, specialty labels, feature labels, FAQ titles. The
 * Arabic tab was typed into a left-to-right field, so the caret sat on the
 * wrong side and punctuation landed at the wrong end of the string. The field
 * has to follow the language being edited, not the language of the admin's own
 * interface.
 */
export function textDirection(language: string): "ltr" | "rtl" {
  return RTL_LANGUAGES.has(language) ? "rtl" : "ltr";
}
